// Need to use the React-specific entry point to import createApi
import { getToken } from "./localStorageService";
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const userApi = baseApi.injectEndpoints({
  credentials: "include",
  // tagTypes: ['User'],
  // global configuration for the api
  // refetchOnFocus: true,
  endpoints: (builder) => ({
    // addUser: builder.mutation({
    //   query: (user) => {
    //     return {
    //       url: "add_user",
    //       method: "POST",
    //       body: user,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //         authorization: `Bearer ${getToken()}`,
    //       },
    //     };
    //   },
    //   // invalidatesTags: ['User'],
    // }),
    // updateUser: builder.mutation({
    //   query: (user) => {
    //     return {
    //       url: "update_user",
    //       method: "POST",
    //       body: user,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //         authorization: `Bearer ${getToken()}`,
    //       },
    //     };
    //   },
    //   // invalidatesTags: ['User'],
    // }),
    deleteUser: builder.mutation({
      query: (id) => {
        return {
          url: `user/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllUsers: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `get-all-users?${queryParams}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          //   authorization: `Bearer ${getToken()}`,
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    changeUserPass: builder.mutation({
      query: ({ data, id }) => {
        return {
          url: `change-user-password/${id}`,
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: ["User"],
    }),

    blockUnblockUser: builder.mutation({
      query: ({ id }) => {
        return {
          url: `/block-user/${id}`,
          method: "PUT",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getUserContentAnalytics: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `content-actions/content-analytics?${queryParams}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          //   authorization: `Bearer ${getToken()}`,
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useDeleteUserMutation,
  useGetAllUsersQuery,
  useChangeUserPassMutation,
  useBlockUnblockUserMutation,
  useGetUserContentAnalyticsQuery,
} = userApi;
